export default "__VITE_ASSET__d8e10537__"